<template>
  <div class="drug-info contant-wrap">
    <div class="filter-data">
      <h3>效期提醒</h3>
      <div class="filter-control">
        <el-row>
          <el-col :span="8">
            <div class="rows">
              <label for="">失效日期：</label>
              <el-select v-model="query.days" placeholder="请选择" @change="getTableData(1)">
                <el-option
                  v-for="item in daysList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="rows">
              <label for="">药品分类：</label>
              <el-select v-model="query.drugType" placeholder="请选择" @change="getTableData(1)">
                <el-option
                  v-for="item in drugType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="8">
            <div>
              <el-button type="success" @click="fileExport"  class="button">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-table :data="drugList" :header-cell-style="{background: '#ECEBEB', color: '#1A1A1A'}" style="width: 100%" class="table">
      <el-table-column prop="drugName" label="药品名称">
        <template slot-scope="scope">
          <img src="../../../assets/images/logo-l.png" class="logo-img"  v-if="scope.row.isShopDrugs === 1"/>
          {{scope.row.drugName}}
        </template>
      </el-table-column>
      <el-table-column prop="drugType" label="药品分类">
        <template slot-scope="scope">
          {{scope.row.drugType | setDrugType}}
        </template>
      </el-table-column>
      <el-table-column prop="specification" label="规格">
      </el-table-column>
      <el-table-column prop="manufacturer" label="厂家">
      </el-table-column>
      <el-table-column prop="batchInventory" label="批次库存">
      </el-table-column>
      <el-table-column prop="drugBatchNo" label="批号">
      </el-table-column>
      <el-table-column prop="time" label="失效日期">
        <template slot-scope="scope">
          <span :class="{'red': scope.row.overdue == 0}">{{ scope.row.time }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="option" label="操作" min-width="55">
        <template slot-scope="scope">
          <el-button type="text" @click="toOutDetail(scope.row.outOfStockId)">出库</el-button>
        </template>
      </el-table-column> -->
  </el-table>
  <div class="pagination" v-if="drugList.length > 0">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="query.currentPage"
      :page-sizes="pageSizes"
      :page-size.sync="query.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
  </div>
</template>

<script>
import { pageSizes, drugType } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';

export default {
  name: 'home',
  mixins: [pageSize],
  data() {
    return {
      pageSizes,
      drugType,
      drugList: [], // 消息列表
      total: 100, // 总数据条数
      query: {
        drugType: -1, // 药品分类
        currentPage: 1,
        days: '30', // 失效日期
        pageSize: 20,
      },
      daysList: [{
        value: '30',
        label: '一个月内',
      }, {
        value: '7',
        label: '一周内',
      }, {
        value: '60',
        label: '两个月内',
      }, {
        value: '90',
        label: '三个月内',
      }, {
        value: '180',
        label: '半年内',
      }, {
        value: '365',
        label: '一年内',
      }, {
        value: '0',
        label: '已过期',
      }],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    toOutDetail(outOfStockId) {
      const query = {
        state: 'addValidity',
        outOfStockId,
      };
      this.$router.push({ name: 'purchaseRetreat', query });
    },
    // 获取药品列表信息
    getTableData(type) {
      if (type === 1) {
        this.query.currentPage = 1;
      }
      this.$api.drugControl.validity(this.query).then((res) => {
        this.drugList = res.drugList;
        this.total = res.totalSize;
      });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(value) {
      this.query.currentPage = value;
      this.getTableData();
    },
    // 导出
    fileExport() {
      if (this.drugList.length < 1) {
        this.$alert('没有药品信息，请更换查询条件试试', '提示', {
          confirmButtonText: '确定',
        }).catch(() => {
        });
      } else {
        this.$api.drugControl.validityExport(this.query);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.red {
  color: #f56c6c;
}
</style>
